import { Component, Input, Output, EventEmitter, ViewChild , ElementRef, Injectable} from '@angular/core';
import { MzBaseModal, MzModalComponent } from 'ngx-materialize';
import { procesadores } from 'src/app/_models/formularios/procesadores.model';

/*
 * Modal para actualización de procesadores
 * 
 * By: fruiz
 */
@Component({ templateUrl: './modaleditProc.component.html'})

@Injectable()
export class ModalsComponentProcEdit extends MzBaseModal {
  public proc: procesadores;
  //Variables que provienen de los campos
  @ViewChild('IDPROC') IDPROC: ElementRef;
  @ViewChild('DSCPROC') DSCPROC: ElementRef;
  @ViewChild('VALORPROC') VALORPROC: ElementRef;
  @ViewChild('WarningProc') WarningProc: MzModalComponent;
  @ViewChild('ErrorEditProc') ErrorEditProc: MzModalComponent;
  // datos de entrada por el servicio de modal
  @Input() public id: number;
  @Input() public dsc: string;
  @Input() public valor: number;
  // Emitter para envío de parámetros
  @Output() updateProc:EventEmitter<procesadores>;
 
  public modalOptions: Materialize.ModalOptions = {
    dismissible: false, 
    opacity: .5,
    inDuration: 300, 
    outDuration: 200, 
    startingTop: '100%', 
    endingTop: '10%'  
  };

  constructor() {        
    super(); 
    this.updateProc = new EventEmitter(); 
    this.proc= new procesadores();
    
  }

  ngOnInit(){
    this.proc.idAnt=this.valor;
  }

  cancelar(){
    this.modalComponent.closeModal();
    this.WarningProc.closeModal();
  }

  // Aceptando el modal 
  public closeModal() {
        this.proc.id=this.IDPROC.nativeElement.value;
        this.proc.dsc=this.DSCPROC.nativeElement.value;
        this.proc.valor=this.VALORPROC.nativeElement.value;
        this.proc.dsc=this.proc.dsc.trim();
        if (this.proc.valor == null ||
          this.proc.dsc == null  ||
          this.proc.dsc.trim().length == 0 ||
          this.proc.valor.toString().trim().length == 0) {
            
          this.ErrorEditProc.openModal();
        } else {          
          if(this.proc.idAnt != this.proc.valor){
            this.WarningProc.openModal();
          } else { 
            this.updateProc.emit(this.proc);
            this.modalComponent.closeModal(); 
          }
        }
  }

  public closeModalwarning(){
    this.proc.id=this.IDPROC.nativeElement.value;
    this.proc.dsc=this.DSCPROC.nativeElement.value; 
    this.proc.dsc=this.proc.dsc.trim(); 
    this.proc.valor=this.VALORPROC.nativeElement.value; 
    this.updateProc.emit(this.proc);
    this.cancelar();
  }
}
